import { Component, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';

export enum HeadingType {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}

export enum HeadingSize {
  XSMALL = 'heading3',
  SMALL = 'heading2',
  MID = 'heading1',
  LARGE = 'hero-compact',
  XLARGE = 'hero',
}

export enum HeadingColor {
  DARK = 'dark',
  MID = 'mid',
  LIGHT = 'light',
}

export enum HeadingWeight {
  BOLD = 'bold',
  NORMAL = 'normal',
}

@Component({
  selector: 'fl-heading',
  template: `
    <ng-container [ngSwitch]="headingType">
      <h1 *ngSwitchCase="HeadingType.H1"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-weight]="weight"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </h1>

      <h2 *ngSwitchCase="HeadingType.H2"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-weight]="weight"
       >
         <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
       </h2>

      <h3 *ngSwitchCase="HeadingType.H3"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-weight]="weight"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </h3>

      <h4 *ngSwitchCase="HeadingType.H4"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-weight]="weight"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </h4>

      <h5 *ngSwitchCase="HeadingType.H5"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-weight]="weight"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </h5>

      <h6 *ngSwitchCase="HeadingType.H6"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-weight]="weight"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </h6>
      <ng-template #injectedContent><ng-content></ng-content></ng-template>
    </ng-container>
`,
  styleUrls: ['./heading.component.scss'],
})
export class HeadingComponent extends BaseComponent {
  HeadingType = HeadingType;
  HeadingSize = HeadingSize;
  HeadingColor = HeadingColor;

  @Input() color = HeadingColor.DARK;
  @Input() size: HeadingSize;
  @Input() weight = HeadingWeight.BOLD;
  @Input() headingType: HeadingType;
}



// WEBPACK FOOTER //
// ./src/@freelancer/ui/heading/heading.component.ts